import React from 'react'
import PropTypes from 'prop-types'
import { Box, CircularProgress } from '@mui/material'

/**
 * Component to display loading state
 */
const WidgetLoader = ({ t_ }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%'
      }}
      title={t_ ? t_('Loading...') : 'Loading...'}
      aria-label={t_ ? t_('Loading...') : 'Loading...'}
    >
      <CircularProgress size={30} />
    </Box>
  )
}

WidgetLoader.propTypes = {
  t_: PropTypes.func
}

export default WidgetLoader
